import * as React from "react";
import { Row, Col } from "react-bootstrap";
import "./Item.scss";
import PropTypes from "prop-types";

const Item = (props) => {
  return (
    <div key="our-numbers-item">
      {props.itemsData.map((el) => (
        <Row
          key={el.id}
          className="pt-lg-4 our-numbers-row d-lg-flex flex-lg-row align-items-lg-start justify-content-lg-start flex-column"
        >
          <Col className="col-lg-12 our-numbers-info-digit pt-lg-0 mt-lg-0 pt-3 pb-3">
            {el.number}
          </Col>
          <Col className="col-lg-12 our-numbers-info-title pb-3">
            {el.title.title}
          </Col>
          <Col className="col-lg-12 our-numbers-info-description">
            {el.description.description}
          </Col>
        </Row>
      ))}
    </div>
  );
};

Item.propTypes = {
  itemsData: PropTypes.object.isRequired,
};

export default Item;
